<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <VSelect
      v-model="improvementInitiative.client"
      :label="$t('forms.labels.client')"
      outlined
      disabled
      :items="[client]"
    />
    <VSelect
      v-model="improvementInitiative.site"
      :label="$t('forms.labels.site')"
      outlined
      disabled
      :items="[site]"
    />
    <VTextField
      v-model="improvementInitiative.massBalanceName"
      :label="$t('forms.labels.massBalanceName')"
      outlined
      disabled
    />
    <VTextField
      v-model="improvementInitiative.projectName"
      :label="$t('forms.labels.projectName')"
      outlined
      :rules="{ required: true }"
      type="text"
      @change="onInput"
    />
    <VTextarea
      v-model="improvementInitiative.projectDescription"
      :label="$t('forms.labels.projectDescription')"
      outlined
      :rules="{ max: 500, required: true}"
      type="text"
      @change="onInput"
    />
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <VSelect
          v-model="improvementInitiative.waterSavingsUnit"
          :items="waterSavingUnits"
          :label="$t('massBalance.e4Form.improvementInitiative.waterSavingsUnit')"
          outlined
          :rules="{ required: true }"
          @input="onInput"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <VSelect
          v-model="improvementInitiative.energySavingUnit"
          :items="energySavingUnits"
          :label="$t('massBalance.e4Form.improvementInitiative.energySavingUnit')"
          outlined
          :rules="{ required: true }"
          @input="onInput"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <VSelect
          v-model="improvementInitiative.co2EmissionsUnit"
          :items="co2EmissionsUnits"
          :label="$t('massBalance.e4Form.improvementInitiative.co2EmissionsUnit')"
          outlined
          :rules="{ required: true }"
          @input="onInput"
        />
      </v-col>
    </v-row>
    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirty-changed', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('valid-changed', valid)"
    />
  </ValidationObserver>
</template>

<script>
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import { mapGetters, mapActions } from 'vuex';
import { WATER_SAVINGS_UNITS, ENERGY_SAVINGS_UNITS, CO2_EMISSIONS_UNITS } from '@/aquassist-shared/constants/massBalance';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';


export default {
    name: 'ImprovementInitiative',
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        VSelect,
        VTextField,
        VTextarea,
    },
    props: {
        massBalanceName: {
            type: String,
            default: null,
        },
        editMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            improvementInitiative: {
                client: null,
                site: null,
                massBalanceName: null,
                projectName: null,
                projectDescription: null,
                waterSavingsUnit: null,
                energySavingUnit: null,
                co2EmissionsUnit: null,
            },
            isInitialized: false,
        };
    },
    computed: {
        ...mapGetters([
            'client',
            'site',
            'e4Config',
        ]),
        waterSavingUnits() {
            return Object.values(WATER_SAVINGS_UNITS || {}).map(item => ({
                id: item,
                name: this.$t(`massBalance.e4Form.units.${item}`),
            }));
        },
        energySavingUnits() {
            return Object.values(ENERGY_SAVINGS_UNITS || {}).map(item => ({
                id: item,
                name: this.$t(`massBalance.e4Form.units.${item}`),
            }));
        },
        co2EmissionsUnits() {
            return Object.values(CO2_EMISSIONS_UNITS || {}).map(item => ({
                id: item,
                name: this.$t(`massBalance.e4Form.units.${item}`),
            }));
        },
    },
    created() {
        if (this.editMode) {
            this.improvementInitiative = { ...this.e4Config.improvementInitiative } || {};
            this.improvementInitiative.client = {
                id: this.e4Config.improvementInitiative.client.id,
                name: this.e4Config.improvementInitiative.client.name,
            };
        }
        this.improvementInitiative.client = {
            id: this.e4Config.improvementInitiative.client.id,
            name: this.e4Config.improvementInitiative.client.name,
        };

        this.improvementInitiative.site = {
            id: this.e4Config.improvementInitiative.site.id,
            name: this.e4Config.improvementInitiative.site.name,
        };

        this.improvementInitiative.massBalanceName = this.e4Config.improvementInitiative.massBalanceName;
        this.isInitialized = true;
    },

    methods: {
        ...mapActions({
            setE4Config: 'setE4Config',
        }),
        async onInput() {
            if (this.isInitialized) {
                this.setE4Config({ improvementInitiative: this.improvementInitiative });
            }
        },

    },

};
</script>
